<template>
  <div class="am-post-payment">
    <div class="am-header am-main-top-box">
      <span class="am-title am-main-top-box-title"><strong>Alert</strong></span>
    </div>
    <p class="am-post-payment-content">Please wait while we post your payment.</p>
    <div class="am-loading-screen-payment"></div>
    <div class="am-blue-border"></div>
  </div>
</template>

<script>
    export default {
        name: "FinanceCompanyPayment"
    }
</script>

<style scoped>
  .am-post-payment {
    width: 500px;
    background-color: whitesmoke;
  }

  .am-post-payment-content {
    padding: 15px;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

  .am-loading-screen-payment {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url(../assets/spinner-anim2.gif);
    background-position: center center;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    height: 100px;
    background-size: 100px;
  }
</style>